import { integracoesApi } from '../clients/AxiosClients'

export const getIntegracoesDisponiveis = async () => {
	return integracoesApi.get('/integracao')
}

export const buscarInformacoesDeIntegracao = async () => {
	return integracoesApi.get('/integracoesvallourec/buscar-informacoes-de-integracao')
}

export const sincronizarDados = async (body) => {
	return integracoesApi.post(
		'/integracoesvallourec/integrar-processamento-smartforest-com-sap',
		body,
	)
}

export const limparDados = async () => {
	return integracoesApi.get(
		'/integracoesvallourec/limpar-log-de-dados-ja-integrados-do-ambiente-de-teste',
	)
}

export const buscarPlantiosIntegrados = async () => {
	return integracoesApi.get('/integracoesvallourec/buscar-plantios-integrados')
}
